import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {IoCheckmarkCircle, IoAlertCircle, IoDocument} from 'react-icons/io5';
import * as yup from 'yup';
import docIcon from './document.png';
import {MdDeleteForever} from "react-icons/md";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import caseFileDeclined from "../../enums/CaseFileDeclined";
import CaseStatus from "../../enums/CaseStatus";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";
import caseNotiFicationEnum from "../../enums/CaseNotiFicationEnum";
import nomenclatureEnum from "../../enums/nomenclatureEnum";


const ReuploadDeclinedDocument = ({
                                      caseFiles,
                                      permitTypeId,
                                      onClose,
                                      onFileAdded,
                                      onCaseStatusChange,
                                      resetUploadTrigger,
                                      startUpload,
                                      setAllFilesUploaded,
                                      orderDepartment
                                  }) => {
    const [declinedFiles, setDeclinedFiles] = useState([]);
    const filesToUpdate = caseFiles.filter(file => file.decline === CaseFileDeclined.DeclinationDocument)
    const PreviouslyDeclinedFile = caseFiles.filter(file => file.decline === CaseFileDeclined.Yes)
    const [fileTypes, setFileTypes] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRefs = useRef({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const params = new URLSearchParams(window.location.search);
    const caseType = parseInt(params.get('id'), 10);
    const [formattedFileNames, setFormattedFileNames] = useState({});
    const [isNoButtonDisabled, setIsNoButtonDisabled] = useState(false);
    const [modalText, setModalText] = useState("დარწმუნებული ხართ?");
    const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(true);

    useEffect(() => {
        const allUploaded = fileTypes.every(
            fileType => uploadedFiles[fileType.id] !== null && !fileErrors[fileType.id]
        );
        setAllFilesUploaded(allUploaded);
    }, [uploadedFiles, fileErrors, fileTypes, setAllFilesUploaded]);


    useEffect(() => {
        if (declinedFiles.length !== 0) {
            void fetchData();
        }
    }, [declinedFiles]);

    useEffect(() => {
        const filteredFiles = caseFiles.filter(file => file.decline === CaseFileDeclined.Yes);
        setDeclinedFiles(filteredFiles);
    }, [caseFiles]);


    const fetchData = async () => {
        try {
            setIsLoadingFileTypes(true)
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`)
            if (response.data.success) {
                const declinedFileTypeIds = new Set(
                    declinedFiles.map(file => file.fileTypeId)
                );

                let filteredData = response.data.data.filter(fileType =>
                    fileType.caseId === permitTypeId &&
                    declinedFileTypeIds.has(fileType.id)
                );
                const specialFiles = declinedFiles.filter(f => f.fileTypeId === 404)

                specialFiles.forEach(file => {
                    filteredData.push({
                        id: 88888888888,
                        title: file.name,
                        extension: '.pdf',
                        required: true,
                        sort: 9999,
                        inActiveIsInspectionSertificate: null,
                        registeryDocumentType: null
                    })
                })


                if (orderDepartment === nomenclatureEnum.building) {
                    filteredData.push({
                        id: 8888888888,
                        title: "ხარვეზზე პასუხის წერილი",
                        extension: ".pdf",
                        required: true,
                        sort: 9999,
                        inActiveIsInspectionSertificate: null,
                        registeryDocumentType: null
                    });
                }



                filteredData = filteredData.sort((a, b) => a.sort - b.sort)

                const newUploadProgress = {}
                const newUploadedFiles = {}
                const newFileErrors = {}
                const newFileInputRefs = {}

                filteredData.forEach(fileType => {
                    newFileInputRefs[fileType.id] = React.createRef()
                    newUploadProgress[fileType.id] = 0
                    newUploadedFiles[fileType.id] = null
                    newFileErrors[fileType.id] = null
                })

                setFileTypes(filteredData)
                setUploadProgress(newUploadProgress)
                setUploadedFiles(newUploadedFiles)
                setFileErrors(newFileErrors)
                fileInputRefs.current = newFileInputRefs
            }
        } catch {
        }
        setIsLoadingFileTypes(false)
    }

    const handleBoxClick = (fileTypeId) => {
        fileInputRefs.current[fileTypeId].current.click();
    };


    const updateFileStatus = async (files) => {
        try {
            await Promise.all(files.map(async (file) => {
                const updatedFile = {
                    ...file,
                    decline: caseFileDeclined.DeclinationDocumentApproved
                };

                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFile);
            }));

        } catch (error) {
        }
    };


    const updatePreviouslyDeclinedFilesStatus = async (files) => {
        try {
            await Promise.all(files.map(async (file) => {
                const updatedFile = {
                    ...file,
                    decline: caseFileDeclined.PreviouslyDeclinedFile
                };

                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFile);
            }));

        } catch (error) {
        }
    };

    const handleFileChange = (fileType, event) => {
        const file = event.target.files[0];

        if (file) {

            const maxSizeBytes = 5000 * 1048576;

            if (file.size > maxSizeBytes) {
                setFileErrors(prevState => ({
                        ...prevState,
                        [fileType.id]: `ფაილის ზომა აღემატება 5000MB.`

                    })
                );
                if (fileInputRefs.current[fileType.id]) {
                    fileInputRefs.current[fileType.id].current.value = "";
                }
                return;
            }

            let formattedName = file.name;
            if (formattedName.length > 30) {
                const fileExtension = formattedName.substring(formattedName.lastIndexOf('.'));
                formattedName = formattedName.substring(0, 27) + '...' + fileExtension;
            }

            setFormattedFileNames(prevState => ({...prevState, [fileType.id]: formattedName}));
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            if (!fileType.extension.includes(fileExtension)) {
                setFileErrors(prevState => ({...prevState, [fileType.id]: "არასწორი ფორმატი!"}));
                setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
            } else {
                setFileErrors(prevState => ({...prevState, [fileType.id]: null}));

                setUploadedFiles(prevState => ({...prevState, [fileType.id]: file}));

                let progress = 0;
                const interval = setInterval(() => {
                    progress += 10;
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: progress}));
                    if (progress >= 100) {
                        clearInterval(interval);
                    }
                }, 200);
            }

            event.target.value = null;
        }
    };

    const handleViewDocument = (fileType) => {
        const file = uploadedFiles[fileType.id];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };

    const validateUploads = async () => {
        let schema = yup.object().shape({});
        fileTypes.forEach(fileType => {
            if (fileType.required || true) {
                schema = schema.shape({
                    [fileType.id]: yup.mixed().required(`დოკუმენტი სავალდებულოა!`)
                });
            }
        });

        try {
            await schema.validate(uploadedFiles, {abortEarly: false});
            return true;
        } catch (err) {
            err.inner.forEach(error => {
                setFileErrors(prev => ({...prev, [error.path]: error.message}));
            });
            return false;
        }
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });


    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: parseInt(caseId, 10),
                caseStatus: CaseStatus.Sent.id,
                action: caseNotiFicationEnum.userSentDeclinedFile.id
            });

        } catch (error) {
        }
    };


    const sendNotificationObject = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseNotificationRangeByCaseId`, {
                caseId: caseId,
                caseStatus: CaseStatus.Sent.id,
                action: caseNotiFicationEnum.userSentDeclinedFile.id
            });

        } catch (error) {
        }
    };

    const removeCaseUsers = async (caseId) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/RemoveAllCaseUserExceptForTheHeadofAgency`, {
                caseID: parseInt(caseId, 10),
            });

        } catch (error) {
        }
    };

    const performUpload = async () => {
        setIsNoButtonDisabled(true);

        try {
            for (const fileType of fileTypes) {
                const file = uploadedFiles[fileType.id];
                if (file) {
                    const fileBase64 = await toBase64(file);
                    const name = fileType.title;
                    const fileData = {
                        caseID: caseType,
                        name,
                        ext: file.name.split('.').pop(),
                        file: fileBase64,
                        mainInfo: "",
                        additionalInfo: "",
                        shared: true,
                        blank: false,
                        documentType: 0,
                        internal: CaseFilesInternal.No,
                        status: CaseFilesStatus.Sent,
                        decline: CaseFileDeclined.No,
                        ...((fileType.id !== 8888888888 && fileType.id !== 88888888888) && {fileTypeId: fileType.id}),
                        declinedInternalStatus: 0,
                        registeryDocumentType: fileType.registeryDocumentType,
                        inActiveIsInspectionSertificate: fileType.isinspectionSertificate
                    }


                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
                }
            }

            setIsNoButtonDisabled(false);
            setModalText("დარწმუნებული ხართ?");

            const urlParams = new URLSearchParams(window.location.search);
            const caseId = urlParams.get('id');
            if (caseId) {
                if (orderDepartment === nomenclatureEnum.building) {
                    await removeCaseUsers(parseInt(caseId, 10));
                }
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, {
                    caseId: parseInt(caseId, 10),
                    caseStatus: CaseStatus.CaseCreatedWithFiles.id,
                    finished: false
                });

                if (orderDepartment === nomenclatureEnum.registery) {
                    await sendNotificationObject(parseInt(caseId, 10));
                } else {
                    await sendNotification(parseInt(caseId, 10))
                }

            }


            if (filesToUpdate.length > 0) {
                await updateFileStatus(filesToUpdate);
            }
            if (PreviouslyDeclinedFile.length > 0) {
                await updatePreviouslyDeclinedFilesStatus(PreviouslyDeclinedFile);
            }


            onCaseStatusChange()
            onFileAdded();

            setAlertMessage("ოპერაცია წარმატებით დასრულდა");
            setAlertType("success");
        } catch (error) {
            setAlertMessage("Error: " + error.message);
            setAlertType("error");
        } finally {
            setIsModalOpen(false);
            onClose();
        }
    };


    const handleDeleteFile = (fileType) => {
        setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
        setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
        setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
        setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
    };


    const handleUploadFiles = async () => {
        if (!await validateUploads()) {
            return;
        }
        setIsModalOpen(true);
    };

    useEffect(() => {
        if (startUpload) {
            void handleUploadFiles();
            resetUploadTrigger();
        }
    }, [startUpload, resetUploadTrigger]);

    return (
        <div>

            <div>

                {isLoadingFileTypes && fileTypes.length === 0 ? (<div><LoaderCustomFixed/></div>) : (
                    <div className="file-upload-container-reupload">
                        {fileTypes.map(fileType => (
                            <div>
                                <div key={fileType.id}
                                     className={`file-box ${uploadProgress[fileType.id] === 100 ? 'upload-complete' : ''}`}
                                     onClick={() => handleBoxClick(fileType.id)}>
                                    <img src={docIcon} alt="Document" className="document-icon"/>
                                    <div className="file-content">
                                        <div className="file-top">
                                            <div>
                                                <h4 className={"documnet-title"}>{fileType.title}</h4>
                                                <div className={"documnet-title"}>გაფართოება: {fileType.extension}</div>
                                                <div className={"documnet-title"}>მაქსიმალური
                                                    ზომა: 5000MB.
                                                </div>
                                                <div
                                                    className={"documnet-title"}>{formattedFileNames[fileType.id]}</div>
                                            </div>

                                            {uploadProgress[fileType.id] !== 100 && (
                                                <div className="icon-container">
                                                    <IoAlertCircle color="red" fontSize={"24px"}/>
                                                </div>
                                            )}
                                            {uploadProgress[fileType.id] === 100 && (
                                                <div className="icon-container">
                                                    <IoCheckmarkCircle size="24px" color="green"/>

                                                </div>
                                            )}

                                        </div>
                                        {fileErrors[fileType.id] &&
                                            <div className="error-message-doc">{fileErrors[fileType.id]}</div>}


                                        <input
                                            type="file"
                                            ref={fileInputRefs.current[fileType.id]}
                                            style={{display: 'none'}}
                                            accept={`${fileType.extension}`}
                                            onChange={(e) => handleFileChange(fileType, e)}
                                        />
                                    </div>
                                    {uploadProgress[fileType.id] > 0 && uploadProgress[fileType.id] < 100 && (
                                        <div className="progress-bar-container">
                                            <div
                                                className="progress-bar-fill"
                                                style={{width: `${uploadProgress[fileType.id]}%`}}
                                            ></div>
                                            <span className="progress-bar-text">
                                                {uploadProgress[fileType.id]}%
                                            </span>
                                        </div>
                                    )}

                                </div>
                                {uploadProgress[fileType.id] === 100 && (
                                    <div className="documnet-actions-contaioner">

                                        <button className={"view-doc-button"}
                                                onClick={() => handleViewDocument(fileType)}>
                                            <IoDocument/> ნახვა
                                        </button>
                                        <button className={"view-del-button"}
                                                onClick={() => handleDeleteFile(fileType)}>
                                            <MdDeleteForever/> წაშლა
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                )}

                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                    isNoButtonDisabled={isNoButtonDisabled}
                    modalText={modalText}
                />
                {showAlert && (
                    <CustomAlert
                        message={alertMessage}
                        type={alertType}
                        onClose={() => setShowAlert(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default ReuploadDeclinedDocument;
